module.exports = __webpack_public_path__ + "static/img/Dyson_Heppell_mobile.8fdf3fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Dyson_Heppell_mobile.jpg
// module id = Mrhn
// module chunks = 0